import Vue from 'vue';
import Vuex from 'vuex';

// import buckets from './modules/buckets';
// import auth from './modules/auth';
import account from './modules/account';
import auth from './modules/auth';
import user from './modules/user';
import subscription from './modules/subscription';
import payment from './modules/payment';
import plan from './modules/plan';
import coupon from './modules/coupon';
import consent from './modules/consent';
import drive from './modules/drive';
import scope from './modules/scope';

import { setBaseUrl as setBaseAuthUrl } from '@/modules/auth-request';
import ENV_VARS from '@/modules/env-vars.js';


const debug = (process.env.NODE_ENV !== 'production');

Vue.use(Vuex);

// Root Vuex store
export default new Vuex.Store({
	strict: debug,
	modules: {
		auth,
		user,
    	account,
		subscription,
		drive,
		scope,
		payment,
		plan,
		coupon,
		consent
	},
	actions: {

		SET_SERVICE_ROOTS (context) {

			// create a factory for ...
			setBaseAuthUrl(ENV_VARS.AUTH_API);
			context.commit('auth/SET_AUTH_URL', ENV_VARS.AUTH_URL);
			return context.dispatch('auth/SET_AUTH_ROOT', ENV_VARS.AUTH_API);

		}

	}



});



// WEBPACK FOOTER //
// ./src/store/index.js